import {
  USER_TOKEN,
  USER_INFO
} from './mutation-types.js'

export default {
  [USER_TOKEN](state,{ user_token }){
    state.user_token = user_token;
  },
  [USER_INFO](state,{ user_info }){
    state.user_info = user_info;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js